<template>
  <div>
    <div class="flex items-center justify-between mt-2">
      <page-header
        heading="Domains"
        breadcrumb="Settings >> Domains "
      />
      <!-- <search-filter /> -->
    </div>

    <div class="bg-white shadow py-6 mt-8">
      <domains-table />
    </div>
  </div>
</template>

<script>
import PageHeader from "../PageHeader.vue";
// import SearchFilter from "../SearchFilter.vue";
import DomainsTable from "./DomainsTable";
export default {
  components: {
    PageHeader,
    // SearchFilter,
    DomainsTable,
  },
};
</script>

<style></style>
